<template>
  <div class="VideoIndex">
    <!-- Container -->
    <div class="container m-w-1440 w-100 mt-0" >
      <VideoNavigation></VideoNavigation>
      <router-view></router-view>
    </div>
    <!-- /.Container -->
  </div>
</template> 
<script>
import VideoNavigation from "./VideoNavigation.vue";//这个是侧边栏
export default {
name: "VideoBase",
//組件
components:{
  VideoNavigation,
},
//观察器
watch:{

},
//计算属性
computed:{
},
 data() {
   return {
   };
 },
//DOM加載前
created () {
},
//DOM加載后
mounted () {
},
//方法
methods:{
},
}
</script>
<style scoped>
.container.m-w-1440{
  max-width: 1920px !important;
}
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Video/VideoBase.vue